import React, { PureComponent, PropTypes } from 'react';
import EventAccountData from './EventAccountData';
import FormattedAddress from '../FormattedAddress';
import { extractLocation, extractLocationName, isAccountData } from '../../util/EventUtil';

export default class EventLocation extends PureComponent {
  static propTypes = {
    event: PropTypes.shape({
      eventType: PropTypes.string.isRequired
    })
  };

  static defaultProps = {};

  render() {
    const { className, event } = this.props;
    const location = extractLocation(event);
    const locationName = extractLocationName(event);

    if (!location) {
      return <span>TBD</span>;
    }

    const address = (
      <div>
        { location && location.address ? <FormattedAddress address={location.address}/> : null }
      </div>
    );

    return (
      <EventAccountData className={className} highlighted={isAccountData(event, 'location')}>
        <label>{locationName}</label>
        {address}
      </EventAccountData>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/event/EventLocation.jsx